export function isValidHex(hexMinusHash: string) {
  return /^[0-9A-Fa-f]{3}([0-9A-Fa-f]{3})?$/.test(hexMinusHash);
}
